<template>
  <v-container :fluid="wide">
    <!-- <v-card outlined> -->
    <v-tabs background-color="transparent" v-model="tab" color="secondary" grow>
      <v-tab> Llamadas </v-tab>
      <v-tab> Registro </v-tab>
    </v-tabs>

    <v-tabs-items style="background-color: transparent" v-model="tab">
      <!-- LLAMADAS -->
      <v-tab-item>
        <v-container fluid>
          <v-row justify="space-between" align="center">
            <v-col cols="8" md="auto">
              <div class="d-flex flex-row align-center">
                <small class="font-weight-medium pr-2">Activos:</small>
                <v-switch color="success" v-model="showOnlyActives" value="Up" inset></v-switch>
              </div>
            </v-col>

            <v-col cols="8" md="auto" lg="2">
              <v-autocomplete
                :disabled="isLoading"
                :items="newExtensionList"
                v-model="extensionFilter"
                name="Extension"
                item-text="ext"
                item-value="ext"
                filled
                rounded
                single-line
                dense
                class="rounded-small"
                hide-details
                clearable
                multiple
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-data-iterator
            :items="
              extensionFilter.length
                ? newExtensionList.filter((el) => extensionFilter.includes(el.ext))
                : newExtensionList
            "
            :search="showOnlyActives"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:default="{ items }">
              <v-row dense>
                <v-col
                  v-for="item in items"
                  :key="item.name"
                  cols="12"
                  sm="6"
                  :md="wide ? 2 : 4"
                  :lg="wide ? 2 : 3"
                  :xl="wide ? 1 : 2"
                >
                  <v-alert
                    :dark="item.status != ''"
                    dense
                    flat
                    :color="colorAlert(item)"
                    @click.stop="handleShow(item)"
                    style="cursor: pointer"
                  >
                    <v-container>
                      <v-row>
                        <div>
                          <span class="h5" :class="item.status === '' ? 'primary--text' : ''">
                            {{ item.ext }} {{ item.name ? `- ${item.name}` : "" }}
                          </span>
                        </div>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="ml-auto" v-if="item.ip" v-bind="attrs" v-on="on"> mdi-web </v-icon>
                          </template>
                          <span>
                            <v-container class="mb-1">
                              <v-row align="center" justify="space-between">
                                <div>
                                  <v-icon color="white" small class="mr-1"> mdi-web </v-icon>
                                  <span class="body-2">{{ item.ip ? item.ip : "" }}</span>
                                </div>

                                <div>
                                  <v-icon color="white" small class="ml-3 mr-1">
                                    mdi-timer-outline
                                  </v-icon>
                                  <span class="body-2">{{ item.time ? item.time : "0" }}s</span>
                                </div>
                              </v-row>
                            </v-container>
                          </span>
                        </v-tooltip>
                      </v-row>

                      <v-row align="center" justify="space-between">
                        <div>
                          <v-icon small class="mr-2">
                            {{
                              item.status === "Ring"
                                ? "mdi-phone-in-talk"
                                : item.status === "Up"
                                ? "mdi-phone"
                                : "mdi-phone-hangup"
                            }}
                          </v-icon>
                          <span class="body-2">{{ item.dst ? item.dst : "" }}</span>
                        </div>

                        <div>
                          <v-icon small class="mr-2">
                            mdi-timer-outline
                          </v-icon>
                          <span class="body-2">{{ item.duration ? item.duration : "0" }}s</span>
                        </div>
                      </v-row>
                    </v-container>
                    <v-progress-linear
                      v-if="item.status == 'Up'"
                      rounded
                      color="teal darken-4"
                      buffer-value="0"
                      stream
                    ></v-progress-linear>
                    <v-progress-linear
                      v-else-if="item.status == 'Ring'"
                      rounded
                      color="blue darken-3"
                      indeterminate
                    ></v-progress-linear>
                    <v-progress-linear v-else rounded color="rgba(0,0,0,.1)" value="100"></v-progress-linear>
                  </v-alert>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-container>
      </v-tab-item>

      <!-- REGISTRO -->
      <v-tab-item>
        <v-container fluid>
          <v-row justify="space-between" align="center">
            <v-col cols="8" md="auto">
              <div class="d-flex flex-row align-center">
                <small class="font-weight-medium pr-2">Activos:</small>
                <v-switch color="success" v-model="showOnlyActiveRegisters" value="OK" inset></v-switch>
              </div>
            </v-col>

            <v-col cols="8" md="auto" lg="2">
              <v-autocomplete
                :disabled="isLoading"
                :items="newExtensionList"
                v-model="statusRegisterFilter"
                name="Extension"
                item-text="ext"
                item-value="ext"
                filled
                rounded
                single-line
                dense
                class="rounded-small"
                multiple
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-data-iterator
            :items="
              statusRegisterFilter.length
                ? newDetailsExtensionList.filter((el) => statusRegisterFilter.includes(el.ext))
                : newDetailsExtensionList
            "
            :search="showOnlyActiveRegisters"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:default="{ items }">
              <v-row dense>
                <v-col
                  v-for="item in items"
                  :key="item.name"
                  cols="12"
                  sm="6"
                  :md="wide ? 3 : 4"
                  :lg="wide ? 2 : 3"
                  :xl="wide ? 1 : 2"
                >
                  <v-alert
                    :dark="item.status != 'UNKNOWN'"
                    dense
                    flat
                    :color="item.status === 'OK' ? 'success' : ''"
                    @click.stop="handleShow(item)"
                    style="cursor: pointer"
                  >
                    <span class="h5" :class="item.status === 'UNKNOWN' ? 'primary--text' : ''">
                      {{ item.ext }}
                    </span>
                    <v-container class="mb-1">
                      <v-row align="center" justify="space-between">
                        <div>
                          <v-icon small class="mr-2"> mdi-web </v-icon>
                          <span class="body-2">{{ item.ip ? item.ip : "" }}</span>
                        </div>

                        <div>
                          <v-icon small class="mr-2">
                            mdi-timer-outline
                          </v-icon>
                          <span class="body-2">{{ item.time ? item.time : "0" }}s</span>
                        </div>
                      </v-row>
                    </v-container>
                    <v-progress-linear
                      v-if="item.status == 'OK'"
                      rounded
                      color="teal darken-4"
                      buffer-value="0"
                      stream
                    ></v-progress-linear>
                    <v-progress-linear v-else rounded color="rgba(0,0,0,.1)" value="100"></v-progress-linear>
                  </v-alert>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-container>
      </v-tab-item>
    </v-tabs-items>

    <ExtensionDetailDialog
      v-if="isOpenDialog"
      :isActive="isOpenDialog"
      :extension="extensionActive"
      :dataCall="dataActiveCall"
      @close:dialog="closeFormDialog"
    ></ExtensionDetailDialog>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import ExtensionDetailDialog from "./ExtensionDetailDialog.vue";
import { EXTENSION_STATUS_EP } from "./utils";

export default {
  components: {
    ExtensionDetailDialog,
  },

  props: {
    presetAxiosClient: {
      type: Function,
    },
    presetEndpoints: {
      type: Object,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      axiosClient: PbxHttpClient,
      endpoints: EXTENSION_STATUS_EP,
      isOpenDialog: false,
      extensionActive: null,
      dataActiveCall: [],
      extensionFilter: [],
      statusRegisterFilter: [],
      showOnlyActives: "",
      showOnlyActiveRegisters: "",
      tab: null,
      data_extension_all: [],
      cont: 0,
      newExtensionList: [],
      newDetailsExtensionList: [],
    };
  },

  filters: {
    slash(value) {
      if (value.includes("/")) {
        return value.split("/")[1];
      }
      return value;
    },
  },

  computed: {
    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },
    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    allStatus() {
      return this.$store.getters["extension/GET_ALL_STATUS"];
    },
  },

  created() {
    // this.getNewExtensionList();
    // this.getNewDetailsExtensionList();
    // this.mergeExtensionData();
    if (this.presetAxiosClient) this.axiosClient = this.presetAxiosClient;
    if (this.presetEndpoints) this.endpoints = this.presetEndpoints;
    this.getData();

    this.interval = setInterval(() => {
      // this.getNewExtensionList();
      // this.getNewDetailsExtensionList();
      // this.mergeExtensionData();
      this.getData();
    }, 10000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    colorAlert(value) {
      if (value.status === "Ring") {
        return "info";
      }

      if (value.status === "Up") {
        const duration = parseInt(value.duration, 10);
        if (duration < 500) return "success";
        if (duration < 1000) return "warning";
        return "error"; // Si es >= 1000
      }

      if (value.detailStatus === "OK") {
        return "cyan lighten-5";
      }

      return ""; // Caso predeterminado
    },

    closeFormDialog() {
      this.isOpenDialog = false;
      this.extensionActive = null;
    },

    handleShow(value) {
      this.extensionActive = value.ext;
      this.dataActiveCall = value;
      this.isOpenDialog = true;
    },

    async getData() {
      try {
        // Ejecutar las dos solicitudes en paralelo
        const [extensionsResponse, detailsResponse] = await Promise.all([
          this.axiosClient.get(this.endpoints.getNewList),
          this.axiosClient.get(this.endpoints.getNewDetails),
        ]);

        // Asignar los datos recibidos
        const extensions = extensionsResponse.data.data || [];
        const details = detailsResponse.data.data || [];
        this.newDetailsExtensionList =
          detailsResponse.data.data.filter((el) =>
            this.CurrentRole === 10 ? this.ProfileInfo.extensions.includes(el.ext) : el,
          ) || [];

        // Crear un mapa para los detalles con status "OK"
        const detailsMap = new Map(
          details
            // .filter((detail) => detail.status === "OK") // Solo incluir status "OK"
            .map((detail) => [
              detail.ext,
              { ...detail, detailStatus: detail.status }, // Renombrar "status" a "detailStatus"
            ]),
        );

        // Fusionar los datos
        this.newExtensionList = extensions
          .filter((el) => (this.CurrentRole === 10 ? this.ProfileInfo.extensions.includes(el.ext) : el))
          .map((extension) => {
            const matchingDetail = detailsMap.get(extension.ext); // Buscar detalle por "ext"
            return matchingDetail
              ? { ...extension, ...matchingDetail, status: extension.status, name: matchingDetail.name } // Preservar "status" del primer array
              : extension; // Dejar original si no hay coincidencia
          });
      } catch (err) {
        if (err.response.data?.error === "Invalid token" && this.presetAxiosClient) {
          this.$router.push("/");
        } else {
          // Manejo de errores con notificaciones
          this.$snotify.error("Hubo un error consultando o fusionando las extensiones.", "¡Error!");
        }
      }
    },

    // async getNewExtensionList() {
    //   try {
    //     const { data } = await PbxHttpClient.get(`/manager/extension_new`);
    //     this.newExtensionList = data.data;
    //   } catch (err) {
    //     this.$snotify.error(
    //       "Hubo un error consultando las extensiones.",
    //       "¡Error!"
    //     );
    //   }
    // },

    // async getNewDetailsExtensionList() {
    //   try {
    //     const { data } = await PbxHttpClient.get(
    //       `/manager/extension_new_details`
    //     );
    //     this.newDetailsExtensionList = data.data;
    //   } catch (err) {
    //     this.$snotify.error(
    //       "Hubo un error consultando las extensiones.",
    //       "¡Error!"
    //     );
    //   }
    // },

    // mergeExtensionData() {
    //   // Creamos un mapa para buscar rápidamente por "ext" en newDetailsExtensionList
    //   const detailsMap = new Map(
    //     this.newDetailsExtensionList
    //       .filter((detail) => detail.status === "OK") // Solo incluimos los de status "OK"
    //       .map((detail) => [detail.ext, detail]) // Creamos pares clave-valor con "ext" como clave
    //   );

    //   // Fusionamos los datos en newExtensionList
    //   const mergedData = this.newExtensionList.map((extension) => {
    //     const matchingDetail = detailsMap.get(extension.ext); // Buscamos el matching detail por "ext"
    //     return matchingDetail
    //       ? { ...extension, ...matchingDetail } // Fusionamos los datos si hay coincidencia
    //       : extension; // De lo contrario, dejamos el elemento original
    //   });

    //   // Asignamos el resultado fusionado
    //   this.newExtensionList = mergedData;
    // },

    converterToJSON(item) {
      JSON.parse(item);
      return item;
    },

    // async extensionStatus() {
    //   try {
    //     const data = await this.$store.dispatch("extension/EXTENSION_STATUS");

    //     const response_extension = data.data;

    //     let i = 0;
    //     let status_name = false;
    //     let status_mon = false;
    //     let pos_start = 1000;
    //     let pos_end = 1000;
    //     let extension = "";
    //     let data_call = "";
    //     let data_end = "";
    //     let data_extension = [];
    //     let pos_array2 = [];

    //     for (const value of response_extension) {
    //       i++;
    //       // obtengo las variantes de la tarjeta
    //       if (value.includes("Name/username") && status_name == false) {
    //         status = true;
    //         pos_start = i;
    //       }

    //       if (value.includes("Monitored") && status_mon == false) {
    //         status = true;
    //         pos_end = i;
    //       }

    //       if (i > pos_start && i < pos_end) {
    //         extension = value.split(" ");

    //         if (extension[0].includes("Output:")) {
    //           data_extension.push({
    //             name: extension[1],
    //             number: "",
    //           });
    //         } else {
    //           data_extension.push({
    //             name: extension[0],
    //             number: "",
    //           });
    //         }
    //       }

    //       // busco llamada en linea
    //       if (value.includes("!")) {
    //         data_call = value.split("!");
    //         pos_array2.push({
    //           channel: data_call[0],
    //           context: data_call[1],
    //           extension: data_call[2],
    //           priority: data_call[3],
    //           status: data_call[4],
    //           number: data_call[7],
    //           sec: data_call[11],
    //           channel_end: data_call[12],
    //           match: data_call[6].split(",")[0],
    //         });
    //       }
    //     }

    //     let match = pos_array2.filter((index) => {
    //       return index.match.includes("/");
    //     });
    //     // console.log("match", match);

    //     let match2 = pos_array2.filter((index) => {
    //       return !index.match.includes("/");
    //     });
    //     // console.log("match2", match2);

    //     for (const extension of match) {
    //       let data_match2 = match2.find((index) => {
    //         return index.channel.includes(extension.match);
    //       });
    //       if (data_match2 !== undefined) {
    //         let index_data = data_extension.findIndex((index) => {
    //           return index.name.includes(data_match2.extension);
    //         });
    //         // console.log("index_data", index_data);

    //         data_extension[index_data].extension = data_match2.extension;
    //         data_extension[index_data].number = extension.number;
    //         data_extension[index_data].sec = extension.sec;
    //       } else {
    //         let extension_user = data_extension.findIndex((index) => {
    //           return index.name.includes(extension.number);
    //         });
    //         // console.log("extension_user", extension_user);

    //         if (extension_user !== -1) {
    //           // console.log("match2", match2);
    //           let data_match2 = match2.find((index) => {
    //             return index.channel.includes(
    //               extension.match.split("/")[0] +
    //                 "/" +
    //                 extension.match.split("/")[1]
    //             );
    //           });
    //           console.log("data_match2", data_match2);
    //           data_extension[extension_user].extension = extension.number;
    //           data_extension[extension_user].number = data_match2.number;
    //           data_extension[extension_user].sec = data_match2.sec;
    //           // console.log("data_extension", data_extension);
    //         }
    //       }
    //     }

    //     this.data_extension_all = data_extension;
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>

<style scoped>
.border-exten {
  border-left: thin solid rgba(0, 0, 0, 0.12) !important;
}
.border-exten-red {
  border-left: thin solid red !important;
}
.bg-blue {
  background: #625fa4;
  color: white;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #e0e0e0;
  color: black;
}
</style>
